import * as React from "react";
import { useState } from "react";
import AsyncAction from "../AsyncAction";
import sfetch from "../commons/utils/super-fetch";
import { sanitize } from "../commons/utils/sanitize";

interface AskResetPasswordProps {
  onPasswordResetAsked: () => void;
}

interface AskResetPasswordState {
  email: string;
  showEmailError: boolean;
}

const AskResetPassword = (props: AskResetPasswordProps) => {
  const [state, setState] = useState<AskResetPasswordState>({
    email: "",
    showEmailError: false,
  });

  const handleResetPasswordClick = () => {
    return sfetch("/internal-api/v1/users/reset-password-email", {
      method: "POST",
      body: JSON.stringify({
        email: state.email.trim(),
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const handleError = (error) => setState({ ...state, showEmailError: error.status === 400 });

  const handleChange = (event) => setState({ email: event.target.value, showEmailError: false });

  const emailErrorLabel = state.showEmailError ? (
    <small className="error-message" id="error-for-login-email">
      {i18n["Page.Login.Error.MissingUsername"]}
    </small>
  ) : null;

  return (
    <form className="react-form">
      <div className="title-bar">
        <h1 className="title">{i18n["Page.AskPasswordReset.Title"]}</h1>
      </div>

      <p
        dangerouslySetInnerHTML={{
          __html: sanitize(String(i18n["Page.AskPasswordReset.Description"])),
        }}
      />
      <div className="input-group">
        <label htmlFor="login-email">{i18n["Global.EmailAddress"]}</label>
        <input
          id="ask-password-reset-email"
          name="email"
          type="text"
          className={state.showEmailError ? "invalid" : ""}
          placeholder={i18n["Global.EmailAddressPrompt"]}
          onChange={handleChange}
          autoFocus
        />
        {emailErrorLabel}
      </div>
      <div className="action-container">
        <AsyncAction
          buttonLabel={i18n["Page.AskPasswordReset.Submit"]}
          promise={() => handleResetPasswordClick()}
          onError={(error) => handleError(error)}
          onSuccess={() => props.onPasswordResetAsked()}
        />
      </div>
    </form>
  );
};

export default AskResetPassword;
